import { render, staticRenderFns } from "./frontpage.vue?vue&type=template&id=e2ecd778&lang=pug&"
import script from "./frontpage.vue?vue&type=script&lang=js&"
export * from "./frontpage.vue?vue&type=script&lang=js&"
import style0 from "./frontpage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports